import React from 'react';
import { Grid } from '@material-ui/core';
import { PageTemplateDashboard } from '@sierralabs/core-ui';
import FormInfoCard from '../cards/FormInfoCard';
import FormStatusCard from '../cards/FormStatusCard';
export const FormInfoTab = ({ formTemplate, additionalInfoCards, onChange }) => {
    return (React.createElement(PageTemplateDashboard, null,
        React.createElement(Grid, { container: true, spacing: 3 },
            React.createElement(Grid, { item: true, xs: 12, md: 8 },
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FormInfoCard, { formTemplate: formTemplate, onChange: onChange })), additionalInfoCards === null || additionalInfoCards === void 0 ? void 0 :
                    additionalInfoCards.map((AdditionalInfoCard, index) => (React.createElement(Grid, { item: true, xs: 12, key: index },
                        React.createElement(AdditionalInfoCard, { formTemplate: formTemplate })))))),
            React.createElement(Grid, { item: true, xs: 12, md: 4 },
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(FormStatusCard, { formTemplate: formTemplate })),
                    React.createElement(Grid, { item: true, xs: 12 }))))));
};
export default FormInfoTab;
//# sourceMappingURL=FormInfoTab.js.map